// WeightLossServicePage.js
import React from "react";
import DynamicServiceSection from "../components/DynamicServiceSection";
import servicesData from "../data/servicesData";
import NotFound from "./NotFound";

const WeightLossServicePage = ({ path }) => {
  // If the path does not match any key in servicesData, you can show a fallback or a 404
  const {
    sidebarLinks,
    downloadBrochure,
    bannerData,
    featuredImage,
    introText,
    specializationTitle,
    specializationText,
    leftColumnImage,
    rightColumnContent,
    counters,
  } = servicesData[path] || {};

  // If you want to handle invalid paths gracefully:
  if (!servicesData[path]) {
    return <div><NotFound/></div>;
  }

  return (
    <DynamicServiceSection
      sidebarLinks={sidebarLinks}
      downloadBrochure={downloadBrochure}
      bannerData={bannerData}
      featuredImage={featuredImage}
      introText={introText}
      specializationTitle={specializationTitle}
      specializationText={specializationText}
      leftColumnImage={leftColumnImage}
      rightColumnContent={rightColumnContent}
      counters={counters}
    />
  );
};

export default WeightLossServicePage;
